var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinechart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9922 6.96289C20.9902 6.89089 20.9692 6.82289 20.9502 6.75389C20.9352 6.69589 20.9282 6.63689 20.9032 6.58389C20.8802 6.53189 20.8412 6.48989 20.8072 6.44189C20.7652 6.38089 20.7272 6.31989 20.6732 6.26989C20.6642 6.26089 20.6602 6.24889 20.6502 6.24089C20.6142 6.20989 20.5702 6.19889 20.5312 6.17389C20.4712 6.13489 20.4122 6.09489 20.3442 6.06889C20.2772 6.04489 20.2112 6.03889 20.1422 6.02889C20.0942 6.02189 20.0512 5.99989 20.0002 5.99989H15.0002C14.4472 5.99989 14.0002 6.44789 14.0002 6.99989C14.0002 7.55189 14.4472 7.99989 15.0002 7.99989H17.8262L13.7902 12.7079L9.5142 10.1429C9.0912 9.88689 8.5472 9.98089 8.2312 10.3599L3.2312 16.3599C2.8782 16.7839 2.9352 17.4149 3.3592 17.7679C3.5472 17.9239 3.7732 17.9999 3.9992 17.9999C4.2862 17.9999 4.5702 17.8779 4.7682 17.6399L9.2202 12.2979L13.4852 14.8579C13.9042 15.1089 14.4422 15.0209 14.7592 14.6509L19.0002 9.70289V11.9999C19.0002 12.5519 19.4472 12.9999 20.0002 12.9999C20.5532 12.9999 21.0002 12.5519 21.0002 11.9999V6.99989C21.0002 6.98689 20.9932 6.97589 20.9922 6.96289Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinechart);
export default __webpack_public_path__ + "static/media/linechart.4593f451eb3057a610482df8be126f04.svg";
export { ForwardRef as ReactComponent };